<template>
  <patron-profile
    ref="profile"
    @closed="(event) => $emit('closed', event)"
  />
</template>

<script>
  import PatronProfile from "../../../patron/profile/profile.vue";

  export default {
    name: "easyscreen-menu-profile-screen",
    methods: {
      /**
       * Open the overview profile screen.
       */
      show() {
        this.$refs.profile.authenticate();
      },
      /**
       * Close the overview profile screen.
       */
      hide() {
        this.$refs.profile.hide();
      }
    },
    components: {
      "patron-profile": PatronProfile
    }
  };
</script>
